import { cx } from '@emotion/css';
import { useTranslate } from '@tolgee/react';
import { ConversationCategoryType } from 'hooks/business/conversationsHooks/useConversationCategory';

const Item = (props: { active: boolean; onClick: () => void; children: React.ReactNode }) => {
  const { active, onClick, children } = props;
  return (
    <button
      className={cx(
        'px-2 py-1 rounded border-none  cursor-pointer flex-1 text-xs',
        active
          ? 'bg-[var(--fett-bg-elevated)] font-medium text-[var(--fett-text-primary)]'
          : 'bg-[transparent] text-[var(--fett-text-tertiary)]',
      )}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

interface ConversationCategoryProps {
  category: ConversationCategoryType;
  onChange: (category: ConversationCategoryType) => void;
}

export const ConversationCategory = (props: ConversationCategoryProps) => {
  const { category, onChange } = props;
  const { t } = useTranslate();

  const options = [
    {
      label: t('scene.chatWorkspace.conversationList.tab.mine'),
      value: 'mine',
    },
    {
      label: t('scene.chatWorkspace.conversationList.tab.all'),
      value: 'all',
    },
  ] as const;

  return (
    <div className="p-2 border-0 border-b border-solid border-[var(--fett-border-default)]">
      <div className="bg-[var(--fett-bg-subtle)] rounded-[10px] px-1 py-[3px] flex items-center">
        {options.map((option) => (
          <Item
            key={option.value}
            active={category === option.value}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </Item>
        ))}
      </div>
    </div>
  );
};
